module.exports = __webpack_public_path__ + "img/section1.1a028467.png";